import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Logo from '../images/logo.svg';

const Header = ({ siteTitle }) => (
  <header
    className="fixed w-full z-30 top-0"
    style={{ backgroundColor: '#0A0057', height: '82px' }}
  >
    <div className="container mx-auto p-4">
      <Link to="/">
        <img src={Logo} className="w-64" alt={siteTitle} />
      </Link>
    </div>
  </header>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
